import React, { useEffect, useState } from "react";

const Appearance = () => {
    const [isDark, setIsDark] = useState(() => {
        if (localStorage.getItem("theme")) {
            return localStorage.getItem("theme") === "dark";
        }
        return window.matchMedia("(prefers-color-scheme: dark)").matches;
    });

    useEffect(() => {
        document.documentElement.classList.toggle("dark", isDark);
        localStorage.setItem("theme", isDark ? "dark" : "light");
    }, [isDark]);

     return (
        <section id="appearance">
            <h2>Appearance Settings</h2>
            <div className="appearance-setting">
                <div className="setting-text">
                    <h3>Dark Mode</h3>
                    <p>Switch between light and dark themes.</p>
                </div>
                <label className="toggle">
                    <input
                        type="checkbox"
                        checked={isDark}
                        onChange={() => setIsDark(!isDark)}
                    />
                    <span className="slider" />
                </label>
            </div>
        </section>
    );
}

export default Appearance;